import { EMPTY_STRING } from '../constants/grimsby';

export const formatString = (str?: string | null): string =>
    str ? str : EMPTY_STRING;
